// HKDSE 2024 Paper 1 Knowledge Graph Samples - Complete Combined Set
// Merged from hkdse2024Samples_complete.js and hkdse2024Samples_complete_part2.js

import { hkdse2024Samples_complete } from './hkdse2024Samples_complete.js';
import { hkdse2024Samples_complete_part2 } from './hkdse2024Samples_complete_part2.js';

export const hkdse2024Samples_complete_combined = {
  ...hkdse2024Samples_complete,
  ...hkdse2024Samples_complete_part2
};

export { hkdse2024Samples_complete, hkdse2024Samples_complete_part2 }; 